// Native scroll-snap carousel: arrow buttons page the track, swipe stays native.
class SCarousel extends HTMLElement {
  #controller;
  #track;

  connectedCallback() {
    this.#track = this.querySelector('[data-carousel-track]');
    if (!this.#track) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.addEventListener(
      'command',
      (event) => {
        if (event.command === '--next') this.#page(1);
        if (event.command === '--previous') this.#page(-1);
      },
      { signal }
    );

    this.#track.addEventListener('scroll', () => this.#updateButtons(), { passive: true, signal });
    window.addEventListener('resize', () => this.#updateButtons(), { signal });
    this.#updateButtons();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #page(direction) {
    const track = this.#track;
    const card = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    const perPage = Math.max(1, Math.floor((track.clientWidth + gap) / step));
    // Logical direction keeps arrows correct in right-to-left storefronts.
    const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction * rtl * step * perPage, behavior: reduce ? 'auto' : 'smooth' });
  }

  #updateButtons() {
    const track = this.#track;
    const position = Math.abs(track.scrollLeft);
    const max = track.scrollWidth - track.clientWidth - 2;
    for (const button of document.querySelectorAll(`[commandfor="${this.id}"]`)) {
      if (button.getAttribute('command') === '--previous') button.disabled = position <= 2;
      if (button.getAttribute('command') === '--next') button.disabled = position >= max;
    }
  }
}

customElements.define('s-carousel', SCarousel);
